export const normalizeTriggerReasonIds = (triggerReasonId) => {
  if (Array.isArray(triggerReasonId)) {
    return triggerReasonId
      .map((reasonId) => Number(reasonId))
      .filter((reasonId) => !Number.isNaN(reasonId))
  }

  if (triggerReasonId == null) {
    return []
  }

  const singleReasonId = Number(triggerReasonId)
  return Number.isNaN(singleReasonId) ? [] : [singleReasonId]
}

export const isQualifyingTriggerReason = (triggerReasonId) => {
  return normalizeTriggerReasonIds(triggerReasonId).includes(1)
}
